import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { ItemEnvironmentCategory } from "src/model/class/general classes/item-environment-category";

@Component({
    selector: "app-popup-environment-category",
    templateUrl: "./popup-environment-category.component.html",
    styleUrls: ["./popup-environment-category.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupEnvironmentCategoryComponent {
  @Input() header: string = "";
  @Input() categories: Array<ItemEnvironmentCategory> = [];

  constructor(private _modalCtrl: ModalController) {}

  ngOnChanges() {}

  /**
   * Click on category
   * @param category
   */
  public onClickCategory(category): void {
    this._modalCtrl.dismiss(category.id);
  }

  /**
   * Dismiss modal
   */
  public onClickDismiss(): void {
    this._modalCtrl.dismiss();
  }
}
